import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL



export function getConnectorforInstace(SuscriptionId:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorForInstance')
  }

export function getConnectorforInstacetenant(SuscriptionId:any,tenant:any) {
return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorForInstance?tenantId='+tenant)
}

export function getConnectorforInstaceglobal(SuscriptionId:any) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorForInstance')
  }

export function getConnectorforInstacetenantglobal(SuscriptionId:any,tenant:any) {
return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/CTXConnectorForInstance?tenantId='+tenant)
}